<mat-card>
  <mat-card-content class="main-card-content">
    <div class="deposit-action-content">
      <span>Deposit Action Rules</span>
    </div>
    <div class="hint">
      <i class="fas fa-question-circle info-icon"></i>Here we can create rules to perform automatic action on successful
      deposits based on predefined conditions.
    </div>

    @for (rule of rules; track rule; let i = $index) {
      <div class="example-list">
        <app-deposit-ticker-single-rule
          (updated)="update($event, i)"
          (deleted)="deleteElement(i)"
          [data]="rule"></app-deposit-ticker-single-rule>
      </div>
    }
    @if (creatingNew) {
      <div class="example-list">
        <app-deposit-ticker-single-rule
          (cancelled)="creatingNew = !creatingNew"
          (updated)="create($event)"></app-deposit-ticker-single-rule>
      </div>
    }
    @if (!creatingNew) {
      <div>
        @if (rules.length === 0) {
          <span class="info-icon">No rules added yet.</span>
        }
        @if (!creatingNew) {
          <button mat-stroked-button (click)="addRule()">Create</button>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
